export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/calendar/locales/${locale}.json`);

export default getModuleMessages;
